export const restrictedTimingKeys = ['ssr'];
export const clsWaitTimeMs = 7500;